import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhengyan",
  "use": "icon-zhengyan-usage",
  "viewBox": "0 0 21.269 14.179",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21.269 14.179\" id=\"icon-zhengyan\">\r\n  <path id=\"icon-zhengyan_zhengyan\" d=\"M13.755,175.739a1.215,1.215,0,1,1-1.209-1.265,1.848,1.848,0,0,1,.242.044,3.645,3.645,0,0,0-2.154-.72,3.948,3.948,0,0,0,0,7.886,3.854,3.854,0,0,0,3.762-3.937,4.023,4.023,0,0,0-.694-2.258A1.062,1.062,0,0,1,13.755,175.739Zm7.313,1.625c-1.755-3.338-5.9-6.708-10.434-6.708s-8.68,3.37-10.424,6.708l-.21.382.21.382c1.744,3.327,5.885,6.708,10.424,6.708s8.68-3.381,10.434-6.708l.2-.382-.2-.382Zm-10.434,5.9c-3.741,0-7.283-2.782-8.9-5.519,1.618-2.749,5.16-5.519,8.9-5.519s7.282,2.77,8.9,5.519c-1.619,2.737-5.16,5.519-8.9,5.519Z\" transform=\"translate(0 -170.657)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhengyan.svg
// module id = lU9u
// module chunks = 143